export default __webpack_public_path__ + "static/media/C_Cachorro.402f4377.mp3";